<template>
  <div>

    <nav class="navbar navbar-default navbar-fixed-top" role="navigation" id="shrink">

        <div class="container contain-top" id="upper-nav-shrink">

            <div class="contain-top-lower">

                <!-- Brand and toggle get grouped for better mobile display -->

                <div class="navbar-header">


                  <b-navbar-toggle target="navbar-toggle-collapse-mob" class="nav float-right d-lg-none mob-navbar" style="border: 0; outline: none;">
                    <i class="fa fa-bars"   aria-hidden="true"></i>
                  </b-navbar-toggle>



                    <a class="navbar-brand logo-main" :href="mmSiteUrl">
                        <img :src="mmSiteUrl + '/wp-content/themes/Mentor-Mentee/img/Large_Logo_White.png'"
                            alt="Mentor Mentee">
                    </a>



                </div>



                <!-- Collect the nav links, forms, and other content for toggling -->

                <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">




                    <!-- desktop nav -->

                    <div id="dnav">

                      <b-navbar-toggle target="navbar-toggle-collapse" class="nav navbar-nav navbar-right d-none d-lg-block" style="border: 0; outline: none;">
                        <i class="fa fa-bars" aria-hidden="true"></i>
                      </b-navbar-toggle>


                        <ul id="menu-main-menu" class="nav navbar-nav navbar-right d-none d-lg-block">

                            <li id="menu-item-764"
                                class="menu-item menu-item-type-post_type menu-item-object-page menu-item-764 mm-login">
                                <a :href=" mentoringUrl + 'mmlogin'" class="btn btn-orange header_login_btn">Log
                                    In</a>
                            </li>

                        </ul>


                        <ul id="menu-main-menu" class="nav navbar-nav navbar-right d-none d-lg-block" style="margin-top: 4px;">

                            <li id="menu-item-764"
                                class="menu-item menu-item-type-post_type menu-item-object-page menu-item-764 mm-login">
                                <a class="" style="font-size: 19px !important;" href="tel:(888) 800-9250">(888) 800-9250</a>
                            </li>

                        </ul>



                    </div>

                    <!-- desktop nav -->

                    <!-- /.navbar-collapse -->

                </div>

                <!-- /.container -->

            </div>
        </div>


                  <b-collapse id="navbar-toggle-collapse-mob" class="d-lg-none">
                    <b-navbar-nav class=" nav navbar-nav navbar-right" style="width: 100%; margin: 0;">
                      <b-nav-item :href="mmSiteUrl" class="btn btn-danger btn-login">
                        <div class="text-center btn-mobile-cta">
                          Home
                        </div>
                      </b-nav-item>
                      <b-nav-item :href="mmSiteUrl + 'about'" class="btn btn-danger btn-login">
                        <div class="text-center btn-mobile-cta">
                          About Us
                        </div>
                      </b-nav-item>
                      <b-nav-item :href="mmSiteUrl + 'product'" class="btn btn-danger btn-login">
                        <div class="text-center btn-mobile-cta">
                          Product
                        </div>
                      </b-nav-item>
                      <b-nav-item :href="mmSiteUrl + 'pricing'" class="btn btn-danger btn-login">
                        <div class="text-center btn-mobile-cta">
                          Pricing
                        </div>
                      </b-nav-item>
                      <!-- <b-nav-item :href="mmSiteUrl + 'seminar'" class="btn btn-danger btn-login">
                        <div class="text-center btn-mobile-cta">
                          Events
                        </div>
                      </b-nav-item> -->
                      <b-nav-item :href="mmSiteUrl + 'technical-mentoring-news'" class="btn btn-danger btn-login">
                        <div class="text-center btn-mobile-cta">
                          News
                        </div>
                      </b-nav-item>
                      <b-nav-item :href="mmSiteUrl + 'faq'" class="btn btn-danger btn-login">
                        <div class="text-center btn-mobile-cta">
                          FAQs
                        </div>
                      </b-nav-item>
                      <b-nav-item :href="mmSiteUrl + 'contact-us'" class="btn btn-danger btn-login">
                        <div class="text-center btn-mobile-cta">
                          Contact Us
                        </div>
                      </b-nav-item>
                      <b-nav-item href="tel:(888) 800-9250" class="btn btn-danger btn-login">
                        <div class="text-center btn-mobile-cta btn-mobile-cta-tel">
                          (888) 800-9250
                        </div>
                      </b-nav-item>
                      <b-nav-item :href="mentoringUrl + 'mmlogin'" class="btn btn-danger btn-login">
                        <div class="text-center btn-mobile-cta btn-mobile-cta-login">
                          Log In
                        </div>
                      </b-nav-item>
                    </b-navbar-nav>
                  </b-collapse>






                      <b-collapse id="navbar-toggle-collapse">
                        <b-navbar-nav class="top-nav-menu-panel panel panel-default">
                          <b-nav-item :href="mmSiteUrl">
                            Home
                          </b-nav-item>
                          <b-nav-item :href="mmSiteUrl + 'about'">
                            About Us
                          </b-nav-item>
                          <hr />
                          <b-nav-item :href="mmSiteUrl + 'product'">
                            Product
                          </b-nav-item>
                          <b-nav-item :href="mmSiteUrl + 'pricing'">
                            Pricing
                          </b-nav-item>
                          <!-- <b-nav-item :href="mmSiteUrl + 'seminar'">
                            Events
                          </b-nav-item> -->
                          <b-nav-item :href="mmSiteUrl + 'technical-mentoring-news'">
                            News
                          </b-nav-item>
                          <hr />
                          <b-nav-item :href="mmSiteUrl + 'faq'">
                            FAQs
                          </b-nav-item>
                          <b-nav-item :href="mmSiteUrl + 'contact-us'">
                            Contact Us
                          </b-nav-item>
                        </b-navbar-nav>
                      </b-collapse>

    </nav>


    </div>
</template> 
<style scoped>
@import 'https://fonts.googleapis.com/css2?family=Roboto+Condensed:wght@700&display=swap';
.text_bebas {
    font-size: 19px !important;
    font-family: 'bebas-neue-pro', sans-serif;
}
.logo-main img {
    width: 125px;
    height: auto;
    margin-top: 4px;
}
.cta-buttonz {
    float: right;
    margin-top: -2px!important;
    text-transform: uppercase;
    margin-right: 0px;
}
.cta-buttonz img {
    height: 36px;
    width: auto;
}
.navbar > .container {
   display: block !important; 
}
.mm-login {
    margin-top: -6px;
}
.navbar-nav>li {
    float: left;
}
hr {
  border-top: 1px solid #e3e3e3;
  width: 100%;
}
#menu-main-menu li a {
    margin-top: 5px;
}
.navbar a, .navbar a:hover {
    color: #002F42 !important;
    border-right: none;
    text-decoration: none;
    font-size: 16px;
}
.top-nav-menu-panel a:hover {
  background-color: #eee;
}
.top-nav-menu-panel a {
  padding: 0;
}
.navbar-collapse.collapse {
    display: block!important;
}
.navbar-right {
    float: right!important;
    margin-right: 20px;
}
#menu-main-menu {
    margin-right: 20px;
}
.navbar-header {
    float: left;
}
.navbar>.container .navbar-brand, .navbar>.container-fluid .navbar-brand {
    margin-left: -15px;
    margin-top: -15px;
}
.navbar-brand {
   padding: 0px !important;
   float: left;
   height: auto;
   font-size: 18px;
    line-height: 20px;
} 
#dnav {
    margin-top: 0px !important;
}
.container {
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
}
.navbar-dark {
    background-color: #00ACEE !important;
    border-color: #00ACEE !important;
    -webkit-box-shadow: 0px 2px 5px 0px rgb(0 0 0 / 38%) !important;
    -moz-box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.38) !important;
    box-shadow: 0px 2px 5px 0px rgb(0 0 0 / 38%) !important;
    height: 74px !important;
}
.navbar-dark .navbar-nav .nav-link {
    color: #FFF;
}
.navbar a {
    display: block;
}
.nav-item img {
    height: 36px;
    width: auto;
}
.nav-item a{
    text-decoration: none;
    color: #FFF;    
}

@media (min-width: 1200px){
    .container {
        width: 1170px !important;
    }
    #desktop_nav { display: block; }
    #mobile_nav { display: none; }
}
/* Mobile */
@media (min-width:320px) and (max-width: 767px ) {
    .logo-main { margin-left: 10px; }
    .container {
        padding-right: 0px !important;
        padding-left: 0px !important;
    }
    .navbar-collapse {
        margin-top: 0px;
        background: #00ACEE;
        border-color: #00ACEE;
        -webkit-box-shadow: 0px 2px 5px 0px rgb(0 0 0 / 38%);
        -moz-box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.38);
        box-shadow: 0px 2px 5px 0px rgb(0 0 0 / 38%)
    }
    .navbar a { margin-left: 0px !important; margin-top: -10px !important; }
    .navbar-dark .navbar-toggler { margin-right: 25px; }
    .navbar-brand { padding: 10px; }
    .mob_nav_login { 
        margin-left: 0px; margin-top: 0px;
        font-size: 22px !important;
        line-height: 26px !important;
        padding-top: 15px !important;
        padding-bottom: 18px !important;
        background-color: #1c85c8;
        border-color: #00ACEE;
        text-align: center;
        margin-bottom: 10px;
    }
    .mob_nav_app_icons {
        padding: 10px;
        margin: 0px auto;
    }
    .mob_nav_app_icons a {
        margin: 0px;
    }
    .mob_nav_app_icons a {
        display: inline-block;
    }
    .btn-mobile-cta {
      border-bottom: 1px solid #e3e3e3;
    }
}
/* ipad in portrait */
@media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : portrait) { 
    .container {
        padding-right: 0px !important;
        padding-left: 0px !important;
        max-width: 768px;
    }
    .navbar-collapse {
        margin-top: 0px;
        background: #00ACEE;
        border-color: #00ACEE;
        -webkit-box-shadow: 0px 2px 5px 0px rgb(0 0 0 / 38%);
        -moz-box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.38);
        box-shadow: 0px 2px 5px 0px rgb(0 0 0 / 38%)
    }
    .navbar a { margin-left: 30px; }
    .navbar-brand { padding: 10px; }
    .desk_nav_item { display: none !important; }
    .mob_nav_item { display: block !important; }
    .navbar-dark .navbar-toggler { margin-right: 25px; }
    .mob_nav_login { 
        background-color: #1c85c8;
        border-color: #00ACEE;
        font-size: 22px !important;
        line-height: 26px !important;
        padding-top: 15px !important;
        padding-bottom: 18px !important;
        margin-left: 0px; 
        margin-top: 0px;
        margin-bottom: 10px;
        text-align: center;
    }
    .mob_nav_app_icons {
        padding: 10px;
        margin: 0px auto 20px auto;
    }
    .mob_nav_app_icons a {
        display: inline-block;
    }
}
/* ipad in landscape */
@media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : landscape) {
    .container {
        padding-right: 85px;
        padding-left: 85px;
    }
}
/* iPhone XR */
@media only screen and (min-device-width : 414px) and (max-device-width : 896px) and (orientation : landscape) {
    .desk_nav_item { display: none !important; }
    .mob_nav_item { display: block !important; }
    .container {
        max-width: 100% !important;
        padding-right: 0px;
        padding-left: 0px;
    }
    .navbar a { margin-left: 95px; }
    .navbar-dark .navbar-toggler { margin-right: 88px; }
    .navbar-collapse {
        margin-top: -12px;
        background: #00ACEE;
        border-color: #00ACEE;
        -webkit-box-shadow: 0px 2px 5px 0px rgb(0 0 0 / 38%);
        -moz-box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.38);
        box-shadow: 0px 2px 5px 0px rgb(0 0 0 / 38%)
    }
    .mob_nav_login { 
        background-color: #1c85c8;
        border-color: #00ACEE;
        font-size: 22px !important;
        line-height: 26px !important;
        padding-top: 15px !important;
        padding-bottom: 18px !important;
        margin-left: 0px; 
        margin-top: 0px;
        margin-bottom: 10px;
        text-align: center;
    }
    .mob_nav_app_icons {
        padding: 10px;
        margin: 0px auto 20px auto;
    }
    .mob_nav_app_icons a {
        display: inline-block;
    }
}
/* iPhone XS */
@media only screen and (min-device-width : 375px) and (max-device-width : 812px) and (orientation : landscape) {
    .navbar a { margin-left: 56px; }
    .navbar-dark .navbar-toggler { margin-right: 46px; }
}
/* iPhone 5 portrait */
@media only screen and (min-device-width : 320px) and (max-device-width : 568px) {
    .mob_nav_app_icons img {
        width: 126px;
    }
    .navbar a { margin-left: 0px; }
}
/* Samsung A8.0 */
@media only screen and (min-device-width : 601px) and (max-device-width : 962px) and (orientation : portrait) { 
 .container {
 padding-right: 0px !important;
 padding-left: 0px !important;
 max-width: 768px;
 }
}
@media only screen and (min-device-width : 601px) and (max-device-width : 962px) and (orientation : landscape) { 
 .container {
 padding-right: 0px !important;
 padding-left: 0px !important;
 max-width: 962px;
 }
 .desk_nav_item { display: none !important; }
 .mob_nav_item { display: block !important; }
 .mob_nav_app_icons {
 padding: 10px;
 margin: 0px auto;
 }
 .mob_nav_app_icons a {
 margin: 0px;
 }
 .mob_nav_app_icons a {
 display: inline-block;
 }
 .navbar-collapse {
 margin-top: 0px;
 background: #00ACEE;
 border-color: #00ACEE;
 -webkit-box-shadow: 0px 2px 5px 0px rgb(0 0 0 / 38%);
 -moz-box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.38);
 box-shadow: 0px 2px 5px 0px rgb(0 0 0 / 38%)
 }
 .navbar a { margin-left: 30px; }
 .navbar-dark .navbar-toggler { margin-right: 25px; }
 .navbar-brand { padding: 10px; }
 .mob_nav_login { 
 margin-left: 0px; margin-top: 0px;
 font-size: 22px !important;
 line-height: 26px !important;
 padding-top: 15px !important;
 padding-bottom: 18px !important;
 background-color: #1c85c8;
 border-color: #00ACEE;
 text-align: center;
 margin-bottom: 10px;
 }
}
@media (max-width: 320px) {
 .contact-footer { font-size: 12px; }
}
/* ipad Pro */
@media only screen and (min-device-width : 1024px) and (max-device-width : 1366px) and (orientation : portrait) { 
    .desk_nav_item { display: block !important; }
    .mob_nav_item { display: none !important; }
    .navbar-collapse {
        margin-top: 0px;
        background: #00ACEE;
        border-color: #00ACEE;
        -webkit-box-shadow: none;
        -moz-box-shadow: none;
        box-shadow: none;
    }
}
.navbar-default {
    background-color: #00ACEE;
    border-color: #00ACEE;
    -webkit-box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.38);
    -moz-box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.38);
    box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.38);
}
.contain-top {
    margin-top: 5px;
}
@media (min-width: 768px) {
.navbar-header {
    float: left;
}
.navbar-toggle {
    display: none;
}
.navbar-right {
    float: right!important;
    margin-right: -15px;
}
}
.ham-menu {
    background-color: #ffffff;
    font-size: 16px;
}
.navbar-default .navbar-toggle {
    border-color: #ddd;
}
.nav>li {
    position: relative;
    display: block;
    width: 100%;
}
.top-nav-menu-panel {
    background-color: #FFF;
    width: 150px;
    position: absolute;
    right: 94px;
    padding: 15px;
    top: 60px;
    border-radius: 4px;
    border: 1px solid #ddd;    
}
@media (min-width: 1400px) {
.top-nav-menu-panel {
  right: 160px;
}
}
@media (min-width: 1600px) {
.top-nav-menu-panel {
  right: 255px;
}
}
#dnav #menu-main-menu a, #dnav .navbar-nav i {
  color: #FFF !important;
}
.top-nav-menu-panel li a, .top-nav-menu-panel li a:hover, #dnav .navbar-nav i:hover, #dnav .navbar-nav i:active, #dnav .navbar-nav i:focus, #dnav .navbar-nav[aria-expanded="true"] i {
    padding: 0;
    color: #002F42 !important;
}
.ham-menu li {
    margin: 3px 0;
}
.navbar-fixed-top {
    /* height: 66px !important; */
    height: 72px !important;
}
.btn-orange {
    background-color: #EE4200 !important;
    color: #fff;
    border-radius: 7px;
    font-size: 16px !important;
    padding: 5px 20px;
    font-weight: normal;
}
.navbar-fixed-bottom, .navbar-fixed-top {
    position: fixed;
    right: 0;
    left: 0;
    z-index: 1030;
}
.btn-mobile-cta .btn {
    background: #ffffff;
    color: #002F42;
    font-size: 20px !important;
    line-height: 22px !important;
    padding-top: 15px !important;
    padding-bottom: 15px !important;
}
.sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0,0,0,0);
    border: 0;
}
@media (max-width: 991px) {
#ham-toggle .icon-bar {
  background-color: #FFF;
}
.navbar-collapse.collapse.in {
    display: block!important;
    max-height: 100% !important;
}
#navbar-toggle-collapse-mob {
  position: absolute;
  z-index: 1030;
  width: 100%;
  top: 72px;
  text-align: center;
  background-color: #FFF;
}
.navbar-header {
  padding-left: 15px;
  padding-right: 10px;
  width: 100%;
}
body .navbar-toggle {
    margin-bottom: 15px;
    border: none;
    background-color: transparent;
    background-image: none;
    float: right;
    text-align: right;
}
.mob-navbar i {
    display: block;
    height: 4px;
    width: 24px;
    margin-top: 3px;
    color: #FFF;
    font-size: 24px;
}
.mob-navbar[aria-expanded="true"] i {
    padding: 0;
    color: #002F42 !important;
}
.mob-navbar[aria-expanded="false"] i {
    padding: 0;
    color: #FFF !important;
}
#navbar-toggle-collapse-mob li, #navbar-toggle-collapse-mob li a {
  padding: 0;
  margin: 0 !important;
}
#navbar-toggle-collapse-mob li a:hover {
    color: #FFF !important;
}
#navbar-toggle-collapse-mob .btn-danger {
  background: #ffffff !important;
  border: 0;
}
#navbar-toggle-collapse-mob .btn-danger.active, #navbar-toggle-collapse-mob .btn-danger.focus, #navbar-toggle-collapse-mob .btn-danger:active, #navbar-toggle-collapse-mob .btn-danger:focus, #navbar-toggle-collapse-mob .btn-danger:hover, .open > .dropdown-toggle.btn-danger {
    background-color: #00ACEE !important;
    border-color: #00ACEE;
}
body nav .btn-mobile-cta:hover {
  text-decoration: underline;
}
.btn-mobile-cta-tel {
    border-bottom: none;
}
 .btn-login .btn-mobile-cta-tel {
    background-color: #00ACEE !important;
    color: #FFF !important;
}
 .btn-login .btn-mobile-cta-login, .btn-login .btn-mobile-cta-login :hover {
    background-color: #EE4200 !important;
    color: #FFF !important;
}
body nav .btn-mobile-cta {
    color: #002F42 !important;
    font-size: 20px !important;
    line-height: 22px !important;
    font-weight: bold;
    padding-top: 15px !important;
    padding-bottom: 15px !important;
    margin: 0;
}
body nav .btn-mobile-cta:hover{
    color: #FFF !important;
}

}
</style>
<script>
export default {
    props: ['mmSiteUrl'],
    data() {
        return {
          mentoringUrl: process.env.VUE_SITE_URL,
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/mm_header.vue